import React, { useEffect } from 'react';
import { AuthNavigation } from '@BUP/navigations';
import { I18nextProvider } from 'react-i18next';
import { useAuth, useGetOrganizations } from '@BUP/hooks';
import i18n from './configs/i18n';

const BraveUp = () => {
  const { user } = useAuth();
  const organizationId = user?.organizations?.id;
  const { data } = useGetOrganizations(organizationId);
  const language = data?.locations?.lenguage.toLowerCase();

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  return (
    <div className="braveup-main-container">
      <I18nextProvider i18n={i18n}>
        <AuthNavigation />
      </I18nextProvider>
    </div>
  );
};

export default BraveUp;
